var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Edit"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Edit_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6223 1.88789C15.2528 2.38768 15.6839 3.04497 15.8346 3.74006C16.0029 4.516 15.8169 5.30349 15.312 5.95448L6.70121 17.0591C6.26594 17.6208 5.61148 17.9484 4.90404 17.9579L1.58187 17.9999H1.57252C1.20997 17.9999 0.895206 17.7479 0.813139 17.3909L0.0610285 14.1213C-0.0989507 13.4251 0.0589509 12.7038 0.495258 12.142L1.6255 10.6836C1.8904 10.3413 2.38073 10.2804 2.71938 10.5503C3.05804 10.818 3.11726 11.3136 2.85132 11.6559L1.72107 13.1143C1.57771 13.2991 1.52577 13.5354 1.57875 13.7643L2.18854 16.4165L4.8843 16.3829C5.11596 16.3798 5.33099 16.2727 5.47435 16.0879L14.0852 4.98324C14.3054 4.69975 14.3812 4.39525 14.3127 4.07606C14.2389 3.73901 14.0083 3.40197 13.6613 3.12792L12.2174 1.98239C11.6585 1.54139 10.87 1.3146 10.3319 2.01074L9.19439 3.47652L10.9999 4.94019C11.3354 5.21109 11.3894 5.70773 11.1204 6.04583C10.9666 6.24112 10.7402 6.34192 10.5116 6.34192C10.3413 6.34192 10.1688 6.28522 10.0254 6.16867L8.23347 4.71655L5.28736 8.51644C5.02142 8.85873 4.53214 8.92068 4.19244 8.64979C3.85482 8.38204 3.79561 7.88645 4.06051 7.54415L9.10505 1.03845C10.0836 -0.225729 11.7977 -0.349627 13.1783 0.743406L14.6223 1.88789ZM10.5963 16.425H17.2209C17.651 16.425 18 16.7778 18 17.2125C18 17.6472 17.651 18 17.2209 18H10.5963C10.1652 18 9.81717 17.6472 9.81717 17.2125C9.81717 16.7778 10.1652 16.425 10.5963 16.425Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/Edit.7940d88eab5db7e549d5d4107a09c556.svg";
export { ForwardRef as ReactComponent };